import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";

import { Badge, Divider, Icon, Modal, Select, Table, Tooltip } from "antd";
import { ADD_PATIENT_DETAILS } from "../../ActionTypes/ActionTypes";
import "./FetchOrderList.css";

const { confirm } = Modal;
const { Option } = Select;

class FetchIncompleteOrderList extends Component {
  state = {
    editStatus: false,
    loading: false,
    data: [],
  };

  componentDidMount = () => {
    // this.loadData();
    this.getOrder();
  };

  getOrder = () => {
    const { history } = this.props;

    this.setState({
      loading: true,
    });
    axios({
      method: "get",
      url: "/orders/search_by_status.json?status=Incomplete",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        this.setState({
          data: response.data,
          loading: false,
        });
      })
      .catch(() => {
        history.push("/login");
      });
  };

  editStatusChange = () => {
    this.setState({
      editStatus: true,
    });
  };

  handleUserClick = (url, order_id, user_id, start_date, end_date) => {
    const { setOrderValuesInStore, history } = this.props;
    const id = order_id;
    setOrderValuesInStore({
      order_id,
      user_id,
      doctor_id: "",
      photo_link: "",
      start_date,
      end_date,
    });
    history.push(`/orders/${id}`);
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This order will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/orders/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        })
          .then((response) => {
            console.log(response.data);
            window.location.reload();
          })
          .catch((error) => console.log(error));
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  handleStatusChange = (record, value) => {
    axios({
      method: "put",
      url: `/orders/${record.id}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        order: {
          status: value,
        },
      },
    }).then(() => {
      window.location.reload();
    });
  };

  render() {
    const { editStatus, data, loading } = this.state;

    const statusList = ["Active"];

    const statusOption = statusList.map((size) => (
      <Option key={size}>{size}</Option>
    ));

    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        fixed: "left",
        width: 100,
        align: "center",
      },
      {
        title: "Name",
        fixed: "left",
        width: 200,
        render: (record) => (
          <span
            onClick={() =>
              this.handleUserClick(
                record.user.url,
                record.id,
                record.user.id,
                record.start_date,
                record.end_date
              )
            }
            role="button"
          >
            {/* <a href="">{record.user.first_name} {record.user.last_name}</a> */}
            {record.user.is_vip === false ? (
              <a href="">
                {record.user.first_name} {record.user.last_name}
              </a>
            ) : (
              <span>
                <a href="">
                  {record.user.first_name} {record.user.last_name}
                </a>{" "}
                <Badge count="VIP" style={{ backgroundColor: "#52c41a" }} />
              </span>
            )}
          </span>
        ),
      },
      {
        title: "Location",
        render: (record) => record.partner_location.name,
      },
      {
        title: "Start Date",
        render: (record) =>
          record.carefill_count === 0 ? "Yet to start" : record.start_date,
      },
      {
        title: "Status",
        render: (record) =>
          !editStatus ? (
            record.status
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select a reason"
              defaultValue={record.status}
              optionFilterProp="children"
              onChange={(value) => this.handleStatusChange(record, value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {statusOption}
            </Select>
          ),
      },
      {
        title: "Action",
        render: (record) => (
          <span>
            <Tooltip placement="top" title="Edit">
              <span>
                <a
                  onClick={() => this.setState({ editStatus: !editStatus })}
                  role="button"
                >
                  <Icon type="edit" />
                </a>
              </span>
            </Tooltip>

            <Divider type="vertical" />

            <Tooltip placement="top" title="Delete Order">
              <span
                onClick={() => this.showDeleteConfirm(record.id)}
                role="button"
              >
                <a>
                  <Icon type="delete" style={{ color: "red" }} />
                </a>
              </span>
            </Tooltip>
          </span>
        ),
      },
    ];

    return (
      <div style={{ width: "90%", margin: "auto", marginTop: "5%" }}>
        <h2 style={{ textAlign: "center" }}>Incomplete Orders</h2>
        <hr width="100px" />

        <Table
          style={{ marginTop: "5%" }}
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered
          pagination={false}
          // scroll={{ x: 1600 }}
          size="small"
          rowKey="id"
        />
        <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  medicineList: state.AppState.medicineList,
});
const mapDispatchToProps = (dispatch) => ({
  setOrderValuesInStore: (data) =>
    dispatch({ type: ADD_PATIENT_DETAILS, data }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FetchIncompleteOrderList);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/FetchIncompleteOrderList.js